import { passkeysGateway } from "@/gateways/passkeysGateway";
import type { MutationCallbacks } from "@/types";
import { startAuthentication } from "@simplewebauthn/browser";
import { useMutation } from "@tanstack/vue-query";

export function usePasskeyLogin(callbacks: MutationCallbacks = {}) {
  const mutation = useMutation({
    mutationFn: async () => {
      const { options, challengeId } =
        await passkeysGateway.getAuthenticationOptions();
      try {
        const response = await startAuthentication({ optionsJSON: options });
        await passkeysGateway.verifyAuthentication({
          response,
          challengeId,
        });
        return true;
      } catch (err) {
        if (err instanceof Error && err.name === "NotAllowedError")
          return false;
        throw err;
      }
    },
    onSuccess: (authenticated) => {
      if (authenticated) callbacks.onSuccess?.();
    },
  });

  return { ...mutation, loginWithPasskey: mutation.mutate };
}
